<div class="mdm-properties-page">
  <div class="mdm-properties-page-form-container">

    <pmc-properties-form [pageList]="pageList"
                         [context]="identifierObject"
                         #propertiesForm>
    </pmc-properties-form>
  </div>
</div>
